import { type SvgComponentType } from "@newsela/angelou";

import { adminMenuContainerCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AdminMenu/AdminMenuPopout/AdminMenuPopout.styles";
import {
  ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM,
  ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM,
  ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM,
  ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM,
  STAFF_INTERNAL_TOOLS_ITEMS,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection/PopoutMenuSection";
import { PopoutSectionItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItem/PopoutSectionItem";
import useHasFeature from "@/features/useHasFeature";
import { USER_FEATURE_TO_CRUD_A_CONTENT_PROMOTION_CONFIGURATION } from "@/components/ContentPromotions/constants";
import useGetUserProperties from "@/users/v3/useGetUserProperties";

const AdminMenuPopout = () => {
  const {
    canViewAdminConsole,
    isStaff = false,
    canAccessImplementationGuide,
  } = useGetUserProperties();

  const [canCrudAContentPromotionConfiguration] = useHasFeature(
    USER_FEATURE_TO_CRUD_A_CONTENT_PROMOTION_CONFIGURATION,
  );

  return (
    <div css={adminMenuContainerCss}>
      {canViewAdminConsole && (
        <PopoutMenuSection width="300px" title="Admin tools">
          <PopoutSectionItem
            key={ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM.dataQASelector}
            href={ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM.href}
            title={ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM.title}
            SvgComponent={
              ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM.SvgComponent as SvgComponentType
            }
            dataQASelector={
              ADMIN_TOOLS_MENU_ADMIN_CONSOLE_DASHBOARD_ITEM.dataQASelector
            }
          />

          {canAccessImplementationGuide && (
            <PopoutSectionItem
              key={ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.dataQASelector}
              href={ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.href}
              title={ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.title}
              SvgComponent={
                ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.SvgComponent as SvgComponentType
              }
              dataQASelector={
                ADMIN_TOOLS_MENU_IMPLEMENTATION_GUIDE_ITEM.dataQASelector
              }
            />
          )}
        </PopoutMenuSection>
      )}

      {!isStaff && (
        <PopoutMenuSection width="300px" title="Content settings">
          {canCrudAContentPromotionConfiguration && (
            <PopoutSectionItem
              key={ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.dataQASelector}
              href={ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.href}
              title={ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.title}
              SvgComponent={
                ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.SvgComponent as SvgComponentType
              }
              dataQASelector={
                ADMIN_TOOLS_MENU_CONTENT_PROMOTION_ITEM.dataQASelector
              }
            />
          )}

          <PopoutSectionItem
            key={ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.dataQASelector}
            href={ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.href}
            title={ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.title}
            SvgComponent={
              ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.SvgComponent as SvgComponentType
            }
            dataQASelector={
              ADMIN_TOOLS_MENU_CONTENT_RESTRICTION_ITEM.dataQASelector
            }
          />
        </PopoutMenuSection>
      )}

      {isStaff && (
        <PopoutMenuSection title="Internal staff tools">
          {STAFF_INTERNAL_TOOLS_ITEMS.map(
            ({ title, href, SvgComponent, dataQASelector }) => (
              <PopoutSectionItem
                key={dataQASelector}
                href={href}
                title={title}
                SvgComponent={SvgComponent}
                dataQASelector={dataQASelector}
              />
            ),
          )}
        </PopoutMenuSection>
      )}
    </div>
  );
};

AdminMenuPopout.displayName = "AdminMenuPopout";
export { AdminMenuPopout };
